import { TimelineLite, Elastic } from 'gsap/TweenMax';
import SplitText from '@/assets/lib/gsap-bonus/SplitText'; //eslint-disable-line

import { qs, qsa } from '@/scripts/utils';

export const eventIn = (el) => {
  const splitTitle = new SplitText(qs('.event__title', el), { type: 'lines, chars', linesClass: 'js-splittedlines', wordsClass: 'js-splittedwords', charsClass: 'js-splittedchars' });

  const title = splitTitle.chars;
  const details = qsa('.event__details p', el);
  const info = qsa('.event__info .details', el);

  const tl = new TimelineLite({ paused: true });
  tl
    .add('start')
    .set(el, { autoAlpha: 1 })

    .staggerFrom(title, 1.2, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: Elastic.easeOut.config(0.8, 1),
    }, 0.017)

    .staggerFrom(details, 2.2, {
      y: 10,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(1.2, 0.8),
    }, 0.1, 'start+=0.5')

    .staggerFrom(info, 2, {
      y: 10,
      autoAlpha: 0,
      skewX: -20,
      ease: Elastic.easeOut.config(1.2, 0.8),
    }, 0.05, 'start+=1');

  return tl;
};

export const eventOut = (el) => {
  const title = qsa('.event__title', el);
  const details = qsa('.event__details p', el);
  const info = qsa('.event__info .details', el);

  const tl = new TimelineLite({ paused: true });
  tl
    .add('start')

    .staggerTo(title, 1, {
      yPercent: -10,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(0.8, 1),
    }, 0.017, 'start')

    .staggerTo(details, 1.2, {
      y: -10,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(1.2, 0.8),
    }, 0.1, 'start+=0.15')

    .staggerTo(info, 1.2, {
      y: -10,
      autoAlpha: 0,
      ease: Elastic.easeOut.config(1.2, 0.8),
    }, 0.05, 'start+=0.3');

  return tl;
};



// WEBPACK FOOTER //
// ./src/scripts/timelines/eventPageTransitions.js